<template>
    <div>
        <!-- This should be an alert with backdrop to block any user movements. Once okay button is clicked, the page should refresh to the valid current page -->
        <div class="modal fade inactivity inactivityModal" tabindex="-1" :id="modalId" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content text-center">
                    <div class="modal-body p-4">
                        <p>
                            <slot/>
                        </p>
                        <ColoredButton v-if="type == 'refresh'" class="w-auto" @click="reload">{{ TEXTS.render(`INACTIVITY_DETECTION_OKAY`) }}</ColoredButton>
                        <ColoredButton v-if="type == 'logout'" class="w-auto" @click="setupDetection">{{ TEXTS.render(`INACTIVITY_DETECTION_EXTEND`) }}</ColoredButton>
                        <ColoredButton v-if="type == 'logout'" class="w-auto" @click="logout">{{ TEXTS.render(`INACTIVITY_DETECTION_LOGOUT`) }}</ColoredButton>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import helper from '../../helper';
    import Texts from '../utils/Texts';
    import ColoredButton from './ColoredButton';
    export default {
        components: {
            ColoredButton
        },
        props:{
            secondsToTrigger : Number,
            type : String,
            modalId : String,
            onTrigger : Function
        },
        data() {
            return {
                secondsSinceLastAction : 0,
                pollingIntervalMs : 1000,
                userActivityEvents : [
                    'mousedown', 'mousemove', 'keydown',
                    'scroll', 'touchstart'
                ],
                intervalId : null,
                logoutTimeoutId : null,
            }
        },
        methods: {
            setupDetection(){
                var secondsToTrigger = this.secondsToTrigger
                this.secondsSinceLastAction = 0
                this.$root.$emit("clearInactivityPopups")
                // Debug Mode for Testing
                if(window.location.href.indexOf('pogisifranco') > -1 ){
                    secondsToTrigger = 30
                }

                this.createActivityDetectors()

                // Setup Interval for Detection in intervals 
                var self = this
                this.intervalId = setInterval(function(){
                    self.secondsSinceLastAction++
                    if(self.secondsSinceLastAction >= secondsToTrigger){
                        // Clear Detectors
                        self.removeDetection()

                        // Run Triggers
                        if(self.onTrigger){
                            self.onTrigger()
                        }
                        
                        // Show Popup
                        self.hideAllModals()
                        self.showThisModal()

                        // Clear Interval
                        clearInterval(self.intervalId)

                        if(self.type == 'logout'){
                            self.startLogoutTimeout()
                        }  
                    }
                }, this.pollingIntervalMs)

                this.removeLogoutTimeout()
            },
            createActivityDetectors(){
                this.userActivityEvents.forEach(eventName => {
                    document.addEventListener(eventName, this.reactToActivity, true);
                })
            },
            removeDetection(){
                if(this.intervalId){
                    clearInterval(this.intervalId)
                    this.intervalId = null
                }
                this.userActivityEvents.forEach(eventName => {
                    document.removeEventListener(eventName, this.reactToActivity, true);
                })
            },
            reactToActivity(){
                this.secondsSinceLastAction = 0
            },
            hideAllModals(){
                $(".inactivityModal").modalbs5('hide');
            },
            showThisModal(){
                $('#' + this.modalId).data('bs.modal',null);
                $('#' + this.modalId).modalbs5({
                    show: true,
                    backdrop: 'static',
                    keyboard: false
                })
            },
            reload() {
                window.location.reload()
            },
            startLogoutTimeout(){
                    this.timeoutId = setTimeout(this.logout, 60000)
            },
            removeLogoutTimeout(){
                if(this.timeoutId){
                    clearTimeout(this.timeoutId)
                    this.timeoutId = null
                }
            },
            logout(){
                this.$store.dispatch('logout')
                this.$root.$emit("clearInactivityPopups")
            },
        },
        mounted() {
            var self = this
            this.$root.$on("clearInactivityPopups", function(){
                self.hideAllModals()
            })
            this.setupDetection()
        },
        computed: {
            TEXTS : ()=> Texts,
        },
        destroyed() {
            this.removeDetection()
            this.removeLogoutTimeout()
        }
    }
</script>